import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight'
})
export class HighlightPipe implements PipeTransform {
  transform(value: string, key: string): string {
    if (!value || !key) {
      return value;
    }

    const regex = new RegExp(key, 'gi');
    return value.replace(regex, '<strong>$&</strong>');
  }
}